import request from '@/utils/infrastructure/communication/request';

export async function updateFavorite({ id, isFavorite }) {
  return isFavorite
    ? request.delete(`/entity/favorites/${id}`, {})
    : request.post(`/entity/favorites/${id}`, {});
}
